const t = window.MT;
export {
  t as MT
};
//# sourceMappingURL=index.js.map
